require('./brokerStocksAdvancedBuyView.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const { connect } = require('react-redux');
const { withRouter } = require('react-router-dom');
const trim = require('lodash/string/trim');

// @ commons
const { OKCover } = require('commonsComponents/OKCover');
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const Wizard = require('components/commons/wizard/wizard');
const WizardStep = require('components/commons/wizardStep/wizardStep');
const { OKButton } = require('commonsComponents/OKButton');
const OKBadge = require('components/commons/OKBadge/OKBadge');

// @ components
const BrokerStocksHeader = require('components/broker/brokerProductHeaders/brokerStocksHeader/brokerStocksHeader');
const {
    BrokerStocksAdvancedBuyStep1
} = require('components/broker/brokerStocksAdvancedBuy/brokerStocksAdvancedBuyStep1/brokerStocksAdvancedBuyStep1');
const {
    BrokerStocksAdvancedBuyStep2
} = require('components/broker/brokerStocksAdvancedBuy/brokerStocksAdvancedBuyStep2/brokerStocksAdvancedBuyStep2');
const BrokerStocksAdvancesBuyStep3 = require('components/broker/brokerStocksAdvancedBuy/brokerStocksAdvancedBuyStep3/brokerStocksAdvancedBuyStep3');
const BrokerStocksAdvancedBuySuccess = require('components/broker/brokerStocksAdvancedBuy/brokerStocksAdvancedBuySuccess/brokerStocksAdvancedBuySuccess');
const { BrokerMiFIDBehavior } = require('mifid/components/brokerMiFIDBehavior/brokerMiFIDBehavior');

// @ actions
const BrokerStocksAdvancedBuyActions = require('actions/brokerStocksAdvancedBuy');
const ProductFileActions = require('actions/brokerGetProductFile.js');
const BlockedAccountsAction = require('actions/blockedAccounts');
const BrokerConvenienceMiFIDTestAction = require('mifid/actions/brokerConvenienceMiFIDTest');
const BrokerMiFIDProductsAction = require('mifid/actions/brokerMiFIDProducts');
const BrokerOpenTraderActions = require('actions/brokerOpenTrader');
const CollectivesCommissionsInfoAction = require('actions/collectivesCommissions');


const WebappRender = require('components/conditionalRender/webappRender');
// @ constants
const {
    FIRST_STEP,
    SECOND_STEP,
    THIRD_STEP,
    BROKER_CONVENIENCE_MIFID_TEST_STOCKS_ID,
    BROKER_CONVENIENCE_MIFID_STOCK,
    BROKER_MIFID_VERSION_2,
    COLLECTIVOS_STOCKS_ADVANCE_BUY_LOCATION,
    MYPROFILE_BROKER_EXPLORE_URL,
    MYPROFILE_BROKER_URL,
    BROKER_BUY_SCREEN
} = require('constants/index');

// @ helpers
const { FormattedText, formatText, getFinalTitle } = require('core/i18n').i18n;
const { getDocumentURL } = require('utilities/stringHelper');

class BrokerStocksAdvancedBuyView extends React.Component {
    constructor(props) {
        super(props);

        this.checkMifid = true;

        this.buildWizard = this.buildWizard.bind(this);
        this.buildSuccessful = this.buildSuccessful.bind(this);
        this.getProductDetails = this.getProductDetails.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
    }

    componentDidMount() {
        const { match: { params }, setOrderID, history, immProfile } = this.props;

        this.getProductDetails();
        setOrderID(params.isin, params.iso);
        this.handleMifid(this.props);
        this.props.fetchOpenTraderLink();

        if (immProfile.get('isCollective')) {
            this.props.getCollectivesCommissionsInfo(COLLECTIVOS_STOCKS_ADVANCE_BUY_LOCATION, history);
        }
    }

    componentWillReceiveProps(nextProps) {
        const { setLimitedValueCurrency } = this.props;
        const nextCurrency = nextProps.immProductFile.getIn(['productValue', 'currency']);
        const currentCurrency = this.props.immProductFile.getIn(['productValue', 'currency']);

        if (nextCurrency !== currentCurrency) {
            setLimitedValueCurrency(nextCurrency);
        }

        this.handleMifid(nextProps);
    }

    componentWillUnmount() {
        this.props.reset();
        this.props.resetBlockedAccounts();
    }

    getBreadcrumbData(productFile, isin, iso) {
        return [
            {
                text: formatText('breadcrumb-brokerInvestments'),
                url: MYPROFILE_BROKER_URL
            },
            {
                text: formatText('breadcrumb-brokerAdvancedSearch'),
                url: MYPROFILE_BROKER_EXPLORE_URL
            },
            {
                text: productFile.get('companyName'),
                url: `/myprofile/broker/productFile/${isin}/${iso}`
            },
            {
                text: formatText('breadcrumb-brokerStocksBuy'),
                url: `/myprofile/broker/stocksBuy/${isin}/${iso}`
            },
            {
                text: formatText('breadcrumb-brokerAdvancedOrder'),
                url: ''
            }
        ];
    }

    getProductDetails() {
        const { getProductDetails, match: { params: { isin, iso } } } = this.props;
        return getProductDetails(isin, iso, BROKER_BUY_SCREEN);
    }

    buildSuccessful() {
        const {
            immBrokerStocksAdvancedBuy,
            immStocksContract,
            immProductFile,
            immSearchState
        } = this.props;

        return (
            <div className="row no-gutter">
                <BrokerStocksAdvancedBuySuccess
                    immProductFile={immProductFile}
                    immBrokerStocksAdvancedBuy={immBrokerStocksAdvancedBuy}
                    immStocksContract={immStocksContract}
                    immSearchState={immSearchState}
                />
            </div>
        );
    }

    buildWizard() {
        const {
            immBrokerStocksAdvancedBuy,
            immCollectivesCommissions,
            immStocksContract,
            immProfile,
            immProductFile,
            immSearchState,
            immVariables,
            match: { params },
            immBrokerConvenienceMiFIDTest,
            immBrokerMiFIDProducts,
            onFetchBrokerMiFIDProduct,
            flagBasedFeatures,
            getExtantCostDetails
        } = this.props;

        const catalogData = immProductFile.get('catalogData');
        const immSteps = immBrokerStocksAdvancedBuy.get('steps');
        const visibleStep = immBrokerStocksAdvancedBuy.get('visibleStep');
        const firstStepLoading = immBrokerStocksAdvancedBuy.getIn(['steps', FIRST_STEP, 'loading']);
        const secondStepLoading = immBrokerStocksAdvancedBuy.getIn([
            'steps',
            SECOND_STEP,
            'loading'
        ]);
        const thirdStepLoading = immBrokerStocksAdvancedBuy.getIn(['steps', THIRD_STEP, 'loading']);
        const isCollectiveUser = !!immProfile.get('isCollective');
        const actions = {
            setVisibleStep: this.props.setVisibleStep,
            setWillCancel: this.props.setWillCancel,
            finish: this.props.finish,
            validateStep: this.props.validateStep,
            cancel: this.handleCancel
        };
        const headerMenuData = {
            title: formatText('broker-stocksAdvancedBuyWizardTitle'),
            linksData: []
        };

        if (isCollectiveUser) {
            const commisionsLink = immCollectivesCommissions && immCollectivesCommissions.get('url');
            headerMenuData.extraContent = <OKBadge toUrl={commisionsLink} target={'_blank'} name={formatText('broker-stocksAdvancedBuyWizardBadgeLabel').toUpperCase()} />;
        } else {
            const fees_url = getDocumentURL(immVariables.getIn(['variables', 'parameters', 'documents_urls', 'investments', 'wealth_rate']));
            headerMenuData.linksData.push({
                label: formatText('broker-stocksAdvancedBuyWizardFirstLinkLabel'),
                href: fees_url,
                hasTooltip: false,
                target: '_blank'
            });
        }

        return (
            <Wizard
                wizardClass={'broker-stocks-advanced-buy__wizard'}
                actions={actions}
                immSteps={immSteps}
                stepsAmount={immSteps.size}
                visibleStep={visibleStep}
                hasHeaderMenu={true}
                headerMenuData={headerMenuData}
            >
                <WizardStep
                    position="first"
                    cancelButton={true}
                    addLoadingBehaviour={false}
                    isLoading={firstStepLoading}
                >
                    <BrokerStocksAdvancedBuyStep1 />
                </WizardStep>
                <WizardStep
                    position="middle"
                    cancelButton={true}
                    addLoadingBehaviour={false}
                    isLoading={secondStepLoading}
                >
                    <BrokerStocksAdvancedBuyStep2
                        immBrokerStocksAdvancedBuy={immBrokerStocksAdvancedBuy}
                        immStocksContract={immStocksContract}
                        isin={params.isin}
                        iso={params.iso}
                        catalogData={catalogData}
                    />
                </WizardStep>
                <WizardStep
                    position="last"
                    immFinalButton="broker-stocksAdvancedBuyFinish"
                    cancelButton={true}
                    addLoadingBehaviour={true}
                    isLoading={thirdStepLoading}
                >
                    <BrokerStocksAdvancesBuyStep3
                        immProductFile={immProductFile}
                        immBrokerStocksAdvancedBuy={immBrokerStocksAdvancedBuy}
                        immStocksContract={immStocksContract}
                        immSearchState={immSearchState}
                        immBrokerConvenienceMiFIDTest={immBrokerConvenienceMiFIDTest}
                        immBrokerMiFIDProducts={immBrokerMiFIDProducts}
                        onFetchBrokerMiFIDProduct={onFetchBrokerMiFIDProduct}
                        flagBasedFeatures={flagBasedFeatures}
                        getExtantCostDetails={getExtantCostDetails}
                    />
                </WizardStep>
            </Wizard>
        );
    }

    handleCancel() {
        this.props.history.push(`/myprofile/broker`);
    }

    handleMifid(/*props*/) {
        /*if (!this.checkMifid) {
            return;
        }

        const productName = (props.immProductFile.get('companyName') || '').trim();

        if (!productName) {
            return;
        }

        const isin = props.params.isin;
        const iso = props.params.iso;

        const productUrl = `/myprofile/broker/productFile/${isin}/${iso}`;
        const productMifidId = BROKER_CONVENIENCE_MIFID_TEST_STOCKS_ID;
        const continuationUrl = `/myprofile/broker/stocksAdvancedBuy/${isin}/${iso}`;

        props.onStartConvenienceMiFIDTest(
            productName,
            productUrl,
            productMifidId,
            continuationUrl,
            {
                hideAlreadyPerformTestResult: true,
                productType: BROKER_CONVENIENCE_MIFID_STOCK,
            }
        );

        this.checkMifid = false;*/
    }

    render() {
        const {
            immBrokerStocksAdvancedBuy,
            immMyInvestments,
            immOpenTrader,
            immProductFile,
            match: { params: { iso, isin } }
        } = this.props;
        const mappingBreadcrumb = this.getBreadcrumbData(immProductFile, isin, iso);
        const productName = trim(this.props.immProductFile.get('companyName'));
        const productUrl = `/myprofile/broker/productFile/${isin}/${iso}`;
        const continuationUrl = `/myprofile/broker/stocksAdvancedBuy/${isin}/${iso}`;
        const mifidOptions = {
            hideAlreadyPerformTestResult: true,
            productType: BROKER_CONVENIENCE_MIFID_STOCK
        };

        let contractBoxContent;

        if (immProductFile.get('isFetched')) {
            if (immBrokerStocksAdvancedBuy.get('submitSuccessful')) {
                contractBoxContent = this.buildSuccessful();
            } else {
                contractBoxContent = this.buildWizard();
            }
        }


        return (
            <BrokerMiFIDBehavior
                mifidVersion={BROKER_MIFID_VERSION_2}
                productName={productName}
                productUrl={productUrl}
                continuationUrl={continuationUrl}
                productIsinId={isin}
                productMarketId={iso}
                productMifidId={BROKER_CONVENIENCE_MIFID_TEST_STOCKS_ID}
                mifidOptions={mifidOptions}
            >
                <div className="broker-stocks-advanced-buy-view">
                    <OKCover size="medium" section="broker">
                        <OKHeaderSubPage
                            breadcrumbConfig={mappingBreadcrumb}
                            className="broker-stocks-advanced-buy-view__header"
                            finalTitle={getFinalTitle('broker-stocksAdvancedBuyViewTitle')}
                        >
                            <OKButton inverse={true} modifier="ghost" to={MYPROFILE_BROKER_EXPLORE_URL}>
                                <FormattedText format="firstUppercase" value="broker-goToAdvancedSearch" />
                            </OKButton>
                            <WebappRender>
                                <OKButton inverse={true} modifier="primary" to={immOpenTrader.get('openTraderLink')}>
                                    <FormattedText format="firstUppercase" value="broker-openTraderLabel" />
                                </OKButton>
                            </WebappRender>
                        </OKHeaderSubPage>
                    </OKCover>
                    <section className="broker-stocks-advanced-buy-view__body">
                        <BrokerStocksHeader
                            productFile={immProductFile}
                            immMyInvestments={immMyInvestments}
                            handleUpdate={this.getProductDetails}
                            noBottomButtons={true}
                        />
                        <div className="broker-stocks-advanced-buy-view__wizard">
                            {contractBoxContent}
                        </div>
                    </section>
                </div>
            </BrokerMiFIDBehavior>
        );
    }
}

BrokerStocksAdvancedBuyView.propTypes = {
    history: PropTypes.object.isRequired,
    immBrokerStocksAdvancedBuy: PropTypes.object,
    immOpenTrader: PropTypes.object.isRequired,
    immProductFile: PropTypes.object,
    immProfile: PropTypes.object,
    immStocksContract: PropTypes.object,
    immSearchState: PropTypes.object,
    immMyInvestments: PropTypes.object.isRequired,
    immVariables: PropTypes.object.isRequired,
    reset: PropTypes.func,
    resetBlockedAccounts: PropTypes.func,
    setVisibleStep: PropTypes.func,
    setWillCancel: PropTypes.func,
    validateStep: PropTypes.func,
    finish: PropTypes.func,
    setLimitedValueCurrency: PropTypes.func,
    match: PropTypes.object,
    getProductDetails: PropTypes.func,
    setOrderID: PropTypes.func,
    onStartConvenienceMiFIDTest: PropTypes.func.isRequired,
    immBrokerConvenienceMiFIDTest: PropTypes.object.isRequired,
    immBrokerMiFIDProducts: PropTypes.object.isRequired,
    flagBasedFeatures: PropTypes.object.isRequired,
    onFetchBrokerMiFIDProduct: PropTypes.func.isRequired,
    fetchOpenTraderLink: PropTypes.func.isRequired,
    getExtantCostDetails: PropTypes.func.isRequired,
    getCollectivesCommissionsInfo: PropTypes.func,
    immCollectivesCommissions: PropTypes.object
};

module.exports.constructor = BrokerStocksAdvancedBuyView;
module.exports.BrokerStocksAdvancedBuyView = connect(
    state => ({
        immBrokerStocksAdvancedBuy: state.brokerStocksAdvancedBuy,
        immCollectivesCommissions: state.collectivesCommissions,
        immProductFile: state.brokerProductFile,
        immProfile: state.profile,
        immStocksContract: state.brokerStocksContract,
        immSearchState: state.brokerSearch,
        immMyInvestments: state.brokerMyInvestments,
        immOpenTrader: state.brokerOpenTrader,
        immBrokerConvenienceMiFIDTest: state.brokerConvenienceMiFIDTest,
        immBrokerMiFIDProducts: state.brokerMiFIDProducts,
        immVariables: state.globalVariables,
        flagBasedFeatures: state.flagBasedFeatures,
    }),
    {
        reset: BrokerStocksAdvancedBuyActions.reset,
        resetBlockedAccounts: BlockedAccountsAction.resetBlockedAccounts,
        setVisibleStep: BrokerStocksAdvancedBuyActions.setVisibleStep,
        setWillCancel: BrokerStocksAdvancedBuyActions.setWillCancel,
        validateStep: BrokerStocksAdvancedBuyActions.validateStep,
        getExtantCostDetails: BrokerStocksAdvancedBuyActions.getExtantCostDetails,
        finish: BrokerStocksAdvancedBuyActions.finish,
        setLimitedValueCurrency: BrokerStocksAdvancedBuyActions.setLimitedValueCurrency,
        getProductDetails: ProductFileActions.getProductFileWithCatalogData,
        setOrderID: BrokerStocksAdvancedBuyActions.setOrderID,
        onStartConvenienceMiFIDTest: BrokerConvenienceMiFIDTestAction.start,
        onFetchBrokerMiFIDProduct: BrokerMiFIDProductsAction.fetchMiFIDProduct,
        fetchOpenTraderLink: BrokerOpenTraderActions.fetchLink,
        getCollectivesCommissionsInfo: CollectivesCommissionsInfoAction.getCollectivesCommissionsInfo
    }
)(withRouter(BrokerStocksAdvancedBuyView));
